import { Box, SxProps, Theme, useTheme } from '@mui/material';

import { FC } from 'react';

import Link from 'next/link';
import { pxToRem } from '@/theme/typography';
import { useIntl } from 'react-intl';
import ImageBoxFuture from '../shared/image-box-future';

interface socialIconProps {
  logo: string;
  path: string;
}

export const SocialIcon: FC<socialIconProps> = ({ logo, path }) => {
  const theme = useTheme();
  const sxSocialIcon: Partial<SxProps<Theme>> = {
    backgroundColor: 'white',
    borderRadius: '100%',
    width: pxToRem(50),
    height: pxToRem(50),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transitionDuration: '300ms',
    ':hover': {
      backgroundColor: theme.palette.grey[10],
    },
    ':active': {
      backgroundColor: theme.palette.grey[20],
    },
  };
  const intl = useIntl();
  return (
    <Link href={{ pathname: path }} passHref>
      <Box sx={sxSocialIcon} component='a' target={'_blank'}>
        <ImageBoxFuture
          img={logo}
          title={intl.formatMessage({ id: 'alt.social_logo' })}
          objectFit='contain'
          sx={{
            height: pxToRem(30),
            width: pxToRem(30),
          }}
        />
      </Box>
    </Link>
  );
};

export default SocialIcon;
